export const contactItems = [
  {
    id: 'address',
    icon: '📍',
    label: 'Địa chỉ offline',
    value: 'Chung cư Safira Khang Điền, Quận 9, TP.HCM',
  },
  {
    id: 'online',
    icon: '💻',
    label: 'Học online',
    value: 'Qua Zoom – học từ bất cứ đâu trên cả nước',
  },
  {
    id: 'zalo',
    icon: '📱',
    label: 'Zalo',
    value: '0779909495',
  },
  {
    id: 'facebook',
    icon: '👥',
    label: 'Facebook',
    value: 'https://www.facebook.com/quynhhuong.hongoc',
  },
];
